var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6648 1.30437C13.2634 1.29917 13.8571 1.41325 14.4112 1.63995C14.9653 1.86665 15.4687 2.20143 15.8921 2.62477C16.3154 3.0481 16.6502 3.55151 16.8769 4.10561C17.1036 4.65971 17.2177 5.25342 17.2125 5.85208C17.2073 6.45074 17.0829 7.04238 16.8466 7.59245C16.6112 8.14035 16.2695 8.63609 15.8413 9.051L9.47646 15.4168C9.33068 15.5626 9.13293 15.6445 8.92675 15.6445C8.72056 15.6445 8.52281 15.5626 8.37703 15.4168L2.00763 9.04645C1.16238 8.20094 0.6875 7.0543 0.6875 5.85875C0.6875 4.66321 1.16234 3.51661 2.00759 2.6711C2.85309 1.82585 3.99986 1.35085 5.19541 1.35085C6.39088 1.35085 7.53741 1.82563 8.38291 2.67078L8.92675 3.21416L9.46594 2.67543C9.88082 2.24725 10.3765 1.90559 10.9244 1.67025C11.4745 1.43395 12.0661 1.30957 12.6648 1.30437Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.884c4204882a01be3e061be9e9283143.svg";
export { ForwardRef as ReactComponent };